export default defineNuxtPlugin(() => {
  const { gTagMangerId } = useRuntimeConfig().public

  function gtag() {
    window.dataLayer.push(arguments)
  }

  window.dataLayer = window.dataLayer || []

  gtag('js', new Date())
  gtag('config', gTagMangerId)

  useHead({
    script: [
      {
        src: `https://www.googletagmanager.com/gtag/js?id=${gTagMangerId}`,
        async: true
      }
    ]
  })
})
